import React from "react";
import MobileNav from "../../components/mobile/nav/MobileNav";
import RegisterComponent from "../../components/mobile/register/Register";
import Footer from "../../components/mobile/footer/Footer";

export default function Register() {
  return (
    <>
      <MobileNav />
      <RegisterComponent />
      <Footer />
    </>
  );
}
